module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: 'pretty-order ' + _vm.order.status
  }, [(_vm.orderTypeSingle === 'accomodation') ? _c('div', _vm._l((_vm.order.details.rows.accomodation), function(row) {
    return _c('div', {
      key: row.rowid
    }, [(row.accommodation) ? _c('div', {
      staticClass: "accommodation"
    }, [_c('div', {
      staticClass: "accommodation-image",
      style: ((row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) ? 'background-image:url(' + (row.accommodation.image || (row.accommodation.pool && row.accommodation.pool.image)) + ')' : 'background-size: cover;')
    }), _vm._v(" "), _c('div', {
      staticClass: "booking-facts"
    }, [_c('p', {
      staticClass: "booking-id"
    }, [_vm._v("\n              Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n            ")]), _vm._v(" "), _c('p', {
      staticClass: "booking-title"
    }, [_vm._v("\n              " + _vm._s(row.accommodation.display_name || row.accommodation.description_title)), (row.accommodation.subtitle) ? _c('span', [_vm._v(" – " + _vm._s(row.accommodation.subtitle))]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "arrival-date"
    }, [_vm._v("\n              " + _vm._s(_vm._f("dateRange")([_vm.order.details.firstDate, _vm.order.details.lastDate], 'long', ' – ')) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "spacer",
      staticStyle: {
        "margin-top": "1.5rem"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "button--rounded",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.goToBooking(_vm.order.headlid)
        }
      }
    }, [_vm._v("Visa bokning")])])]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.orderTypeSingle !== 'accomodation') ? _c('div', [_c('div', {
    staticClass: "other"
  }, [_c('div', {
    staticClass: "other-image",
    style: ('background-image:url(' + 'https://cdn.branasgruppen.se/branas/app/uploads/2023/10/27141148/familjmedskidor_hero.jpg' + ');')
  }), _vm._v(" "), _c('div', {
    staticClass: "booking-facts"
  }, [_c('div', [_c('p', {
    staticClass: "booking-id"
  }, [_vm._v("\n              Bokningsnummer: " + _vm._s(_vm.order.resvid) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "booking-title"
  }, [_vm._v("\n              " + _vm._s(_vm.orderTypeVisual) + "\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "arrival-date"
  }, [_vm._v("\n              " + _vm._s(_vm._f("date")(_vm.order.details.firstDate, 'long', ' – ')) + "\n            ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "book-more",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goToBooking(_vm.order.headlid)
      }
    }
  }, [_vm._v("Visa bokning")])])])]), _vm._v(" "), _c('PrettyOrderDetails', {
    attrs: {
      "order": _vm.order,
      "types": ['rental', 'skipass', 'skischool'],
      "openRental": true,
      "openSkipass": true,
      "openSkischool": true,
      "bookMoreCallback": _vm.bookMoreCb
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4ce944"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/PrettyOrder.vue
// module id = 1018
// module chunks = 0